import { CLONE_INTERACTIVE_STARTED, CLONE_INTERACTIVE_FAILED, CLONE_INTERACTIVE_SUCCEEDED, DELETE_INTERACTIVE_STARTED, DELETE_INTERACTIVE_FAILED, DELETE_INTERACTIVE_SUCCEEDED, CREATE_INTERACTIVE_STARTED, CREATE_INTERACTIVE_FAILED, CREATE_INTERACTIVE_SUCCEEDED, ARCHIVE_INTERACTIVE_SUCCEEDED, ARCHIVE_INTERACTIVE_FAILED, UNPUBLISH_INTERACTIVE_STARTED, UNPUBLISH_INTERACTIVE_SUCCEEDED, UNPUBLISH_INTERACTIVE_FAILED, RUN_AB_TEST_STARTED, RUN_AB_TEST_FAILED, RUN_AB_TEST_SUCCEEDED, PICK_AB_TEST_WINNER_FAILED, PICK_AB_TEST_WINNER_STARTED, PICK_AB_TEST_WINNER_SUCCEEDED } from './ActionTypes';
import * as InteractiveApi from 'web-interactives-dashboard-ui/api/interactives';
import * as InteractiveDetailsApi from 'web-interactives-dashboard-ui/api/details';
import { getIsDetailsPage } from 'web-interactives-dashboard-ui/selectors/appStateSelectors';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import router from 'web-interactives-dashboard-ui/history';
import usageTracker from 'web-interactives-dashboard-ui/utils/usageTracker';
import { Metrics } from 'web-interactives-dashboard-ui/utils/metricTracker';
import { captureMessage } from 'web-interactives-dashboard-ui/utils/exceptions';
import { redirectToEditor } from 'web-interactives-dashboard-ui/utils/urls';
import { closeModal } from './ModalActions';
export const createInteractiveStart = () => ({
  type: CREATE_INTERACTIVE_STARTED
});
export const createInteractiveSuccess = response => ({
  type: CREATE_INTERACTIVE_SUCCEEDED,
  response
});
export const createInteractiveFailure = error => ({
  type: CREATE_INTERACTIVE_FAILED,
  error
});
export const deleteInteractiveStart = () => ({
  type: DELETE_INTERACTIVE_STARTED
});
export const deleteInteractiveSuccess = () => ({
  type: DELETE_INTERACTIVE_SUCCEEDED
});
export const deleteInteractiveFailure = error => ({
  type: DELETE_INTERACTIVE_FAILED,
  error
});
export const deleteAllSelected = selectedIds => dispatch => {
  if (!selectedIds || !selectedIds.length) {
    captureMessage('No selectedIds supplied to deleteAllSelected action');
    return Promise.resolve(false);
  }
  const properties = {
    what_value: selectedIds,
    action: 'Delete Interactives',
    event: 'delete-interactives'
  };
  dispatch(deleteInteractiveStart());
  const promises = selectedIds.map(InteractiveApi.deleteInteractive);
  return Promise.allSettled(promises).then(() => {
    dispatch(deleteInteractiveSuccess());
    dispatch(closeModal());
    Metrics.counter('delete-interactive-success').increment();
    usageTracker.trackDashboardInteraction(Object.assign({}, properties, {
      succeeded: true
    }), true);
    return true;
  }).catch(error => {
    dispatch(deleteInteractiveFailure(error));
    Metrics.counter('delete-interactive-failed').increment();
    FloatingAlertStore.addAlert({
      message: I18n.text('errors.delete.message', {
        count: selectedIds.length
      }),
      titleText: I18n.text('errors.delete.title'),
      type: 'danger'
    });
    usageTracker.trackDashboardInteraction(Object.assign({}, properties, {
      succeeded: false
    }), false);
    return false;
  });
};
export const deleteInteractive = id => (dispatch, getState) => {
  dispatch(deleteInteractiveStart());
  const isDetailsPage = getIsDetailsPage(getState());
  const properties = {
    what_value: id,
    action: 'Delete Interactive',
    event: 'delete-interactive'
  };
  return InteractiveApi.deleteInteractive(id).then(() => {
    dispatch(deleteInteractiveSuccess());
    dispatch(closeModal());
    if (isDetailsPage) {
      usageTracker.trackDetailsInteraction(Object.assign({}, properties, {
        succeeded: true
      }), true);
      Metrics.counter('delete-interactive-success').increment();
      router.navigateTo('/manage/state/all');
    } else {
      usageTracker.trackDashboardInteraction(Object.assign({}, properties, {
        succeeded: true
      }), true);
    }
    return true;
  }, error => {
    dispatch(deleteInteractiveFailure(error));
    Metrics.counter('delete-interactive-failed').increment();
    FloatingAlertStore.addAlert({
      message: I18n.text('errors.delete.message', {
        count: 1
      }),
      titleText: I18n.text('errors.delete.title'),
      type: 'danger'
    });
    if (isDetailsPage) {
      usageTracker.trackDetailsInteraction(Object.assign({}, properties, {
        succeeded: false
      }));
    } else {
      usageTracker.trackDashboardInteraction(Object.assign({}, properties, {
        succeeded: false
      }));
    }
    return false;
  });
};
export const cloneInteractiveStart = () => ({
  type: CLONE_INTERACTIVE_STARTED
});
export const cloneInteractiveSuccess = response => ({
  type: CLONE_INTERACTIVE_SUCCEEDED,
  response
});
export const cloneInteractiveFailure = error => ({
  type: CLONE_INTERACTIVE_FAILED,
  error
});
export const cloneInteractive = (id, name) => (dispatch, getState) => {
  const isDetailsPage = getIsDetailsPage(getState());
  const properties = {
    what_value: id,
    action: 'Clone Interactive',
    event: 'clone-interactive'
  };
  dispatch(cloneInteractiveStart());
  // eslint-disable-next-line promise/catch-or-return
  InteractiveApi.cloneInteractive(id, name).then(response => {
    dispatch(cloneInteractiveSuccess(response));
    if (isDetailsPage) {
      usageTracker.trackDetailsInteraction(Object.assign({}, properties, {
        succeeded: true
      }), true);
    } else {
      usageTracker.trackDashboardInteraction(Object.assign({}, properties, {
        succeeded: true
      }), true);
    }
    redirectToEditor(response.id);
  }, error => {
    dispatch(cloneInteractiveFailure(error));
    FloatingAlertStore.addAlert({
      message: I18n.text('errors.clone.message'),
      titleText: I18n.text('errors.clone.title'),
      type: 'danger'
    });
    if (isDetailsPage) {
      usageTracker.trackDetailsInteraction(Object.assign({}, properties, {
        succeeded: false
      }));
    } else {
      usageTracker.trackDashboardInteraction(Object.assign({}, properties, {
        succeeded: false
      }));
    }
  });
};
export const archiveInteractiveSuccess = response => ({
  type: ARCHIVE_INTERACTIVE_SUCCEEDED,
  response
});
export const archiveInteractiveFailure = error => ({
  type: ARCHIVE_INTERACTIVE_FAILED,
  error
});
export const archiveInteractives = (ids, shouldArchive) => dispatch => {
  const properties = {
    action: 'Archive Interactives',
    event: 'archive-interactives'
  };
  return InteractiveApi.archiveInteractives(ids, shouldArchive).then(response => {
    dispatch(archiveInteractiveSuccess(response));
    dispatch(closeModal());
    usageTracker.trackDetailsInteraction(Object.assign({}, properties, {
      succeeded: true
    }), true);
    return true;
  }, error => {
    dispatch(archiveInteractiveFailure(error));
    FloatingAlertStore.addAlert({
      message: I18n.text('errors.archive.message'),
      titleText: I18n.text('errors.archive.title'),
      type: 'danger'
    });
    usageTracker.trackDashboardInteraction(Object.assign({}, properties, {
      succeeded: false
    }));
    return false;
  });
};
export const unpublishInteractiveStart = () => ({
  type: UNPUBLISH_INTERACTIVE_STARTED
});
export const unpublishInteractiveSuccess = () => ({
  type: UNPUBLISH_INTERACTIVE_SUCCEEDED
});
export const unpublishInteractiveFailure = error => ({
  type: UNPUBLISH_INTERACTIVE_FAILED,
  error
});
export const unpublishInteractive = interactiveId => dispatch => {
  const properties = {
    action: 'Unpublish Interactive',
    event: 'unpublish-interactive'
  };
  dispatch(unpublishInteractiveStart());
  InteractiveApi.unpublishInteractive(interactiveId).then(() => {
    dispatch(unpublishInteractiveSuccess());
    dispatch(closeModal());
    usageTracker.trackDetailsInteraction(Object.assign({}, properties, {
      succeeded: true
    }));
    router.navigateTo('/manage/state/all');
  }).catch(error => {
    dispatch(unpublishInteractiveFailure(error));
    FloatingAlertStore.addAlert({
      message: I18n.text('errors.unpublish.message'),
      titleText: I18n.text('errors.unpublish.title'),
      type: 'danger'
    });
    usageTracker.trackDetailsInteraction(Object.assign({}, properties, {
      succeeded: false
    }));
  });
};
export const runAbTestStarted = () => ({
  type: RUN_AB_TEST_STARTED
});
export const runAbTestSuccess = response => ({
  type: RUN_AB_TEST_SUCCEEDED,
  response
});
export const runAbTestFailure = error => ({
  type: RUN_AB_TEST_FAILED,
  error
});
export const runAbTest = (id, masterName, variantName) => async (dispatch, getState) => {
  const isDetailsPage = getIsDetailsPage(getState());
  const properties = {
    what_value: id,
    action: 'Run a test',
    event: 'run-a-test'
  };
  dispatch(runAbTestStarted());
  try {
    const createVariationResult = await InteractiveApi.createVariation(id, variantName);
    dispatch(runAbTestSuccess(createVariationResult));
    try {
      await InteractiveDetailsApi.updateInteractiveName(id, masterName);
    } catch (updateError) {
      console.error('Error updating name', updateError);
      FloatingAlertStore.addAlert({
        message: I18n.text('errors.runAbTest.masterNameUpdateFailed'),
        titleText: I18n.text('errors.runAbTest.title'),
        type: 'warning'
      });
    }
    redirectToEditor(createVariationResult.id);
    if (isDetailsPage) {
      usageTracker.trackDetailsInteraction(Object.assign({}, properties, {
        succeeded: true
      }), true);
    } else {
      usageTracker.trackDashboardInteraction(Object.assign({}, properties, {
        succeeded: true
      }), true);
    }
    return true;
  } catch (error) {
    dispatch(runAbTestFailure(error));
    FloatingAlertStore.addAlert({
      message: I18n.text('errors.runAbTest.message'),
      titleText: I18n.text('errors.runAbTest.title'),
      type: 'danger'
    });
    if (isDetailsPage) {
      usageTracker.trackDetailsInteraction(Object.assign({}, properties, {
        succeeded: false
      }), true);
    } else {
      usageTracker.trackDashboardInteraction(Object.assign({}, properties, {
        succeeded: false
      }), true);
    }
    return false;
  }
};
export const pickAbTestWinnerStarted = () => ({
  type: PICK_AB_TEST_WINNER_STARTED
});
export const pickAbTestWinnerSuccess = response => ({
  type: PICK_AB_TEST_WINNER_SUCCEEDED,
  payload: response
});
export const pickAbTestWinnerFailed = error => ({
  type: PICK_AB_TEST_WINNER_FAILED,
  error
});
export const pickAbTestWinner = (abTestId, winningContentId) => async dispatch => {
  const properties = {
    abTestId,
    winningContentId,
    action: 'Select a test winner',
    event: 'select-test-winner'
  };
  dispatch(pickAbTestWinnerStarted());
  await InteractiveApi.endTestWithWinner(abTestId, winningContentId).then(() => {
    dispatch(pickAbTestWinnerSuccess());
    usageTracker.trackDetailsInteraction(Object.assign({}, properties, {
      succeeded: true
    }));
  }).catch(error => {
    dispatch(pickAbTestWinnerFailed(error));
    usageTracker.trackDetailsInteraction(Object.assign({}, properties, {
      succeeded: false
    }));
    return false;
  });
  return true;
};